module.exports = __webpack_public_path__ + "img/objects-align-bottom.fb14818a.svg";